export const EXPORT_FORMATS = {
  excel: { extension: "xlsx", label: "Excel" },
  pdf: { extension: "pdf", label: "PDF" },
} as const;

export type ExportKind = keyof typeof EXPORT_FORMATS;
